import { RootState } from '../types'

export const getMainBrandSelector = (state: RootState) => state.brand